export default [
    {
        path: '/services/commercial-corporate',
        name: 'services.commercial-corporate',
        component: () => import('@/views/dashboard/commercial-corporate/CommercialCorporateSummary.vue'),
        meta: { 
            service: 'commercial-corporate',
            smallMenu: true,
            active: 'commercial-corporate'
        },
    },

    // LEADS INDEX
    {
        path: '/services/commercial-corporate/leads',
        name: 'services.commercial-corporate.leads',
        component: () => import('@/views/dashboard/LeadsIndex.vue'),
        meta: { 
            service: 'commercial-corporate',
            type: 'lead',
            smallMenu: true,
            active: 'commercial-corporate'
        },
    },
    // LEADS SINGLE
    {
        path: '/services/commercial-corporate/leads/view/:reference?',
        name: 'services.commercial-corporate.leads.view',
        component: () => import('@/views/dashboard/LeadSingle.vue'),
        meta: {
            service: 'commercial-corporate',
            type: 'lead',
            smallMenu: true,
            active: 'commercial-corporate',
        }
    },

    // QUOTES INDEX
    {
        path: '/services/commercial-corporate/quotes',
        name: 'services.commercial-corporate.quotes',
        component: () => import('@/views/dashboard/commercial-corporate/CommercialCorporateQuotesIndex.vue'),
        meta: { 
            service: 'commercial-corporate',
            type: 'quote',
            smallMenu: true,
            active: 'commercial-corporate'
        },
    },
    // QUOTES SINGLE
    {
        path: '/services/commercial-corporate/quotes/view/:reference?',
        component: () => import('@/views/layouts/SingleQuoteWrapper.vue'),
        props: true,
        meta: { 
            service: 'commercial-corporate',
            type: 'quote',
            smallMenu: true,
            active: 'commercial-corporate'
        },
        children: [
            {
                path: '',
                name: 'services.commercial-corporate.quote.view',
                component: () => import('@/components/services/QuoteDetailsTab.vue'),
                props: true,
            },
            {
                path: 'summary',
                name: 'services.commercial-corporate.quote.view.summary',
                component: () => import('@/components/dashboard/commercial-corporate/CommercialCorporateQuoteSummary.vue'),
                props: true,
            },
            {
                path: 'fees',
                name: 'services.commercial-corporate.quote.view.fees',
                component: () => import('@/components/dashboard/misc/QuoteMatterFeesTab.vue'),
                props: true,
            },
            {
                path: 'activity',
                name: 'services.commercial-corporate.quote.view.activity',
                component: () => import('@/components/dashboard/misc/QuoteMatterActivityTab.vue'),
                props: true,
            },
        ],
    },

    // // MATTERS INDEX
    // {
    //     path: '/services/commercial-corporate/matters',
    //     name: 'services.commercial-corporate.matters',
    //     component: () => import('@/views/dashboard/commercial-corporate/CommercialCorporateMattersIndex.vue'),
    //     meta: { 
    //         service: 'commercial-corporate',
    //         type: 'matter',
    //         smallMenu: true,
    //         active: 'commercial-corporate'
    //     },
    // },
]